import {railsPartialQuery} from '@github-ui/react-core/future/rails-partial-query'
import {pullRequestsAppBuilder} from '../config/app-builder'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import type {ConversationRoutePayload} from './route-payload-types'
import {QueryRouteQueryType} from '@github-ui/react-core/future/data-router-types'

export const pullRequestsConversationsRoute = pullRequestsAppBuilder.createQueryRouteConfig(
  'pullRequestsConversationsRoute',
  {
    path: '/:owner/:repo/pull/:pr_number',
    queries: [
      mainQuery<ConversationRoutePayload>(),
      railsPartialQuery({
        partialName: 'Body',
        queryDeps: ({pathname}) => {
          return {pathname: `${pathname}/partials/body`}
        },
      }),
      railsPartialQuery({
        partialName: 'Timeline',
        queryDeps: ({pathname}) => {
          return {pathname: `${pathname}/partials/timeline`}
        },
        type: QueryRouteQueryType.Deferred,
      }),
      railsPartialQuery({
        partialName: 'Sidebar',
        queryDeps: ({pathname}) => {
          return {pathname: `${pathname}/partials/sidebar`}
        },
        type: QueryRouteQueryType.Deferred,
      }),
      railsPartialQuery({
        partialName: 'TimelineActions',
        queryDeps: ({pathname}) => {
          return {pathname: `${pathname}/partials/timeline_actions`}
        },
      }),
    ],
    index: true,
  },
)
